import { toast } from 'sonner'
import { EventoEliminadoError } from '@/core/services/calendarioService'

/**
 * Guarda un evento y anuncia el éxito. Si el evento se borró en el medio (ORR-538), el hook ya
 * avisó: se resuelve sin anunciar nada, y así el diálogo que espera esta promesa se cierra.
 * Abierto invita a guardar de nuevo, y en el alta eso crea otra reunión. Cualquier otro error
 * sigue como antes: rechaza y el diálogo queda abierto.
 */
export const guardarEvento = async (guardado: Promise<unknown>, exito: string) => {
  try {
    await guardado
  } catch (error) {
    if (error instanceof EventoEliminadoError) return
    throw error
  }
  toast.success(exito)
}
